module.exports = __webpack_public_path__ + "img/pg5-title.9765d534.png";